import '../assets/NcFormBoxItem-DiaYRoDl.css';
import { defineComponent, useSlots } from "vue";
import { u as useNcFormBox } from "./useNcFormBox-Djlh582y.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { a as isLegacy32 } from "./legacy-DV3mGZdh.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const __default__ = {
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "NcFormBoxItem",
  props: {
    tag: null,
    label: { default: void 0 },
    description: { default: void 0 },
    invertedAccent: { type: Boolean, default: false },
    itemClasses: { default: void 0 }
  },
  emits: ["click"],
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { formBoxItemClass } = useNcFormBox();
    const descriptionId = createElementId();
    const hasDescription = () => !!props.description || !!slots.description;
    return { __sfc: true, props, slots, formBoxItemClass, descriptionId, hasDescription, isLegacy32 };
  }
});
const formBoxItem = "_formBoxItem_9-pQo";
const formBoxItem__description = "_formBoxItem__description_9iJ-O";
const formBoxItem_legacy = "_formBoxItem_legacy_iQoPw";
const formBoxItem_inverted = "_formBoxItem_inverted_y1uKV";
const formBoxItem__element = "_formBoxItem__element_9-qks";
const formBoxItem__content = "_formBoxItem__content_fsltG";
const formBoxItem__icon = "_formBoxItem__icon_dEMLq";
const style0 = {
  "material-design-icon": "_material-design-icon_EeAM0",
  formBoxItem,
  formBoxItem__description,
  formBoxItem_legacy,
  formBoxItem_inverted,
  formBoxItem__element,
  formBoxItem__content,
  formBoxItem__icon
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [
    _vm.$style.formBoxItem,
    _setup.formBoxItemClass,
    {
      [_vm.$style.formBoxItem_inverted]: _vm.invertedAccent && _setup.hasDescription(),
      [_vm.$style.formBoxItem_legacy]: _setup.isLegacy32
    }
  ] }, [_c("span", { class: _vm.$style.formBoxItem__content }, [_c(_vm.tag, _vm._b({ tag: "component", class: [_vm.$style.formBoxItem__element, _vm.itemClasses], on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } } }, "component", _vm.$attrs, false), [_vm._t("default", function() {
    return [_vm._v(" " + _vm._s(_vm.label || "⚠️ Label is missing") + " ")];
  }, { "descriptionId": _setup.descriptionId })], 2), _setup.hasDescription() ? _c("span", { class: _vm.$style.formBoxItem__description, attrs: { "id": _setup.descriptionId } }, [_vm._t("description", function() {
    return [_vm._v(" " + _vm._s(_vm.description) + " ")];
  })], 2) : _vm._e()], 1), _c("span", { class: _vm.$style.formBoxItem__icon }, [_vm._t("icon", function() {
    return [_vm._v(" ⚠️ Icon is missing ")];
  }, { "descriptionId": _setup.descriptionId })], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcFormBoxItem = __component__.exports;
export {
  NcFormBoxItem as N
};
//# sourceMappingURL=NcFormBoxItem-DasY7_rJ.mjs.map
